import * as React from 'react';
import { DocLayout } from 'src/layouts/DocLayout';
import { Layout } from 'antd';
import { RecallApiDoc } from 'src/containers/RecallApiDoc';

export class RecallApiDocPage extends React.Component {
  render() {
    return (
      <DocLayout>
        <Layout className="doc-root">
            <RecallApiDoc/>
        </Layout>
      </DocLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/RecallApiDocPage/index.tsx